/* eslint-disable */
interface TranlatedPhase {
  [key: string]: string;
}
export const TranslatedQuickPhase: TranlatedPhase = {
  "Replacing evening call through": "Reemplazando llamada",
  "1-3 Days Past Due": "Vencido de 1 a 3 días",
  "3+ Days Past Due": "Vencido de más de 3 días",
  "Cust. Made Good Commitment": "Cliente hizo buen compromiso",
  "Cust. Made Bad Commitment / Request Partial Payment":
    "Cliente hizo un mal compromiso / Solicitar pago parcial",
  "Cust. Already Paid-Proper Pmt.": "Cliente ya pagó - Pago correcto",
  "Store Did Not Receive Pmt.": "La tienda no recibió el pago",
  "Cust. Request Pmt / Payoff Amt.":
    "Cliente solicitó pago / Monto de liquidación",
  "Cust. Request/Confirm Due Date.":
    "Cliente solicitó / Confirma fecha de vencimiento.",
  "Cust. Claims Acct. Is Paid Off or has been returned.":
    "Cliente afirma que la cuenta está pagada o ha sido devuelta.",
  "Cust. Request Return": "Cliente solicitó devolución",
  "Cust. Will Call Store": "Cliente llamará a la tienda",
  "Cust. Attempted Call to Store": "Cliente intentó llamar a la tienda",
  "Cust. Request/States Service Issue":
    "Cliente solicitó / Indicó problema de servicio",
  "Cust. Mentions a Negative Situation (i.e. Job Loss, Sick, Can't Pay , Needs Extension)":
    "Cliente menciona una situación negativa (perdió el trabajo, esta enfermo, Necesita una extensión)",
};
export const TranslatedCategory: TranlatedPhase = {
  "Evening Texts Past Due 1-3 Days":
    "Mensajes vespertinos para vencidos de 1 a 3 días",
  "Evening Texts Past Due 4-7 Days":
    "Mensajes vespertinos para vencidos de 4 a 7 días",
  "Commitment": "Compromiso",
  "Paid / Payment": "Pagado / Pago",
  "Return": "Devolución",
  "Call": "Llamar",
  "Help": "Ayuda",
};
